import { format } from 'date-fns';
import { getAnalytics } from './get-analytics';

import { DATE_TYPE_DAYS, REPORT_TYPES } from '../../../components/tables/reports/consts';
import { ANALYTICS_DATE_FORMAT } from '../../../constants/dateFormats';

export function getSalesByDayAnalytics(onResponse) {
  return getAnalytics({
    kpi: REPORT_TYPES.SALES_BY_DAY,
    omitFilters: ['date_type'],
    additionalParams: {
      group_by: DATE_TYPE_DAYS,
    },
    onResponse,
  });
}

export function getPrevDayAnalytics({ startDate, endDate, onResponse }) {
  return getAnalytics({
    kpi: REPORT_TYPES.SALES,
    omitFilters: ['date_type', 'limit', 'offset', 'sort'],
    additionalParams: {
      group_by: DATE_TYPE_DAYS,
      start_date: format(startDate, ANALYTICS_DATE_FORMAT),
      end_date: format(endDate, ANALYTICS_DATE_FORMAT),
    },
    onResponse,
  });
}

export function getBestSellersAnalytics(onResponse) {
  return getAnalytics({
    kpi: REPORT_TYPES.BEST_SELLERS,
    omitFilters: ['date_type'],
    additionalParams: {
      limit: 5,
    },
    onResponse,
  });
}
